import React, { ButtonHTMLAttributes } from "react";
import styled from "styled-components";

interface Props {
    text: string;
}

// NOTE: Works only within a form
const SubmitButton: React.FC<Props & ButtonHTMLAttributes<HTMLButtonElement>> =
    ({ text, ...delegated }) => {
        return (
            <ButtonContainer>
                <StyledButton type="submit" {...delegated}>
                    {text.toUpperCase()}
                </StyledButton>
            </ButtonContainer>
        );
    };

const ButtonContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 20rem;
    height: 2.8rem;

    font-weight: ${(props) => props.theme.fontWeight.bolder};
    font-size: 1rem;

    transition: all 0.1s ease 0s;

    background: ${(props) => props.theme.colors.primary[500]};
    color: ${(props) => props.theme.colors.neutral[100]};

    box-shadow: 0px 8px 15px rgba(57, 120, 198, 0.15);

    border-radius: 0.2rem;

    &:hover {
        cursor: pointer;
        transform: scale(1.02);
        background: ${(props) => props.theme.colors.primary[400]};
    }

    &:disabled {
        cursor: default;
        background: ${(props) => props.theme.colors.neutral[200]};
        color: ${(props) => props.theme.colors.neutral[400]};
    }
`;

export default SubmitButton;
